import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateCategory from "../../components/ProductManager/Category/UpdateCategory";

export const UpdateCategoryPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateCategory />
        </div>
      </div>
    </div>
  );
};
